@if(meeting?.supprime) {
<div class="mt-1">
  <p-message severity="error" [text]="'Attention, cette séance a été supprimée !'" styleClass="w-100"></p-message>
</div>
}
<section class="meetings-details" *ngIf="currentLayout === 'side-by-side'">
  <as-split direction="horizontal" [dir]="'ltr'">
    <as-split-area [size]="35">
      <div class="me-4">
        <super-title text="{{ meeting?.description }}" level="3" sub="{{ meeting?.seanceTypeName }}" [ngClass]="{
            'green': meeting?.status === 'open',
            'orange': meeting?.status === 'pending',
            'red': meeting?.status === 'closed'
          }" [hasSubtitle]="true" icon="bi bi-arrow-left-circle-fill fa-xl tac-back-icon" (iconClick)="back()"
          [buttons]="buttons"></super-title>
        <div class="alert alert-warning mt-1 mb-0 d-flex justify-content-center flex-column align-items-center"
          *ngIf="alertInfo && alertInfo.length > 0">
          <span *ngFor="let alert of alertInfo">
            {{alert}}<br>
          </span>
        </div>
        <div class="row">
          <div class="col-6">
            <super-button [text]="'infos' | translate" styleClass="blue w-100 mt-3 d-flex justify-content-center"
              icon="bi bi-info-circle-fill" iconPosition="left" (click)="showMeetingInfos()"></super-button>
          </div>
          <div class="col-6">
            <super-button [text]="'sidebar.actions' | translate"
              styleClass="blue w-100 mt-3 d-flex justify-content-center" icon="" iconPosition="left"
              (click)="displayActionsModal2 = true; setDatasWithRights(); setNewStatutModal()"></super-button>
          </div>
        </div>
        <div class="d-flex align-items-center mt-4 mb-4">
          <span class="p-input-icon-left w-100 me-3">
            <i class="pi pi-search"></i>
            <input type="text" styleClass="inputItalicSearchPoint" class="input-rounded w-100 text-center" pInputText
              [(ngModel)]="titleSearch" [placeholder]="'searchPoint' | translate" />
          </span>

          <idel-layout-toggler [(layout)]="currentLayout" (layoutChange)="changeJustifyOptions()"></idel-layout-toggler>
        </div>
        <list-element (emittedPointValue)="receivePointValue($event)" (reloadList)="reload($event)"
          [items]="points | searchByKey: 'title' : titleSearch" *ngIf="points.length > 0"></list-element>
        <div *ngIf="points.length === 0" class="text-center mt-5">
          <i class="bi bi-cup-hot-fill mt-5" style="color: #24344b; opacity: 0.2; font-size: 40px"></i>
          <h3 class="text-center">{{'info.noPoint' | translate}}</h3>
          <p class="text-muted">{{'info.noPointAddMeeting' | translate}}</p>
        </div>
      </div>
    </as-split-area>
    <as-split-area [size]="65">
      <div class="ms-4" *ngIf="points.length > 0">
        <span *ngIf="displayFichePoint">
          <app-fiche-point [pointId]="pointId" (onChangePoint)="reload(true)"></app-fiche-point>
        </span>
        <span *ngIf="displayRTFEditor">
          <app-seance-RTF [meetingId]="meeting.id" [typeRTF]="titleIntroConclusionType"></app-seance-RTF>
        </span>
      </div>
      <div class="ms-4" *ngIf="displayInfos">
        <div>
          <app-infos-meeting [idSent]="meeting.id"
            (emitterChangeDescription)="changedDescriptionOfMeeting($event)"></app-infos-meeting>
        </div>
      </div>
      <div class="ms-4 mt-4 h-100" *ngIf="!somethingIsSelected">
        <section class="pt-3 container-right d-flex flex-column justify-content-center align-items-center">
          <img src="./assets/img/selectPoint.gif" style="height: 200px; width: auto" />
          <h3>{{'actions.selectPoint' | translate}}</h3>
          <p class="text-muted">{{'actions.selectPointInLeftListForViewContent' | translate}}</p>
        </section>
      </div>
    </as-split-area>
  </as-split>
</section>

<section class="meetings-details" *ngIf="currentLayout === 'table'">
  @if(!loading()) {
  <div class="fiche-point-header">
    <div *ngIf="!isReordering" class="d-flex justify-content-between align-items-center pt-2 pb-3 px-2"
      style="border-bottom: 1px solid #60cdff" [ngClass]="{
        'border-bottom-green': meeting?.status === 'open',
        'border-bottom-orange': meeting?.status === 'pending',
        'border-bottom-red': meeting?.status === 'closed'
      }">
      <div class="header__left d-flex align-items-center justify-content-start w-100 me-5">
        <i class="bi bi-arrow-left-circle-fill tacBackIcon me-3 cursor-pointer" style="font-size: 24px"
          (click)="back()"></i>
        <div>
          <div class="d-flex align-items-center justify-content-between">
            <h1 class="mb-2 pointTitle pb-0 me-3">
              {{ meeting?.description }}
            </h1>
            <p class="mb-2 pointSubtitle pb-0">{{ meeting?.seanceTypeName }}</p>
          </div>
          <!-- STATUT DU POINT -->
          <super-button [styleClass]="getStatusClass()" [text]="'global.' + meeting?.status | translate"
            [children]="buttonsTitleTableView[0]?.children" (click)="setNewStatutModal()"></super-button>
        </div>
      </div>
      <div class="courrierView__header__menuR actionsNotPDL">
        <!-- ! flex-direction: row-reverse; a ne pas enlever! Parce que le css ne fonctionne que pour un élément après, pas avant => on a reverse afin que l'élément à gauche soit, dans le DOM, a droite (ca sert pour enlever la border shadow :D ) -->
        <div class="d-flex justify-content-center cursorPointer" style="flex-direction: row-reverse; height: 100%">
          <div
            class="boldFont cursorPointer alignImgTxt ps-3 pe-3 pt-3 pb-3 actionClass d-flex flex-column justify-content-between"
            (click)="displayActionsModal2 = true; setNewStatutModal(); setDatasWithRights()">
            <img src="./assets/img/actions.svg" width="20" height="20" class="img-fluid mb-2" />
            <p class="mb-0">ACTIONS</p>
          </div>
          @if(!shouldDisplayNewMeetingDocument()) {
          <div
            class="boldFont cursorPointer alignImgTxt ps-3 pe-3 pt-3 pb-3 repondreClass d-flex flex-column justify-content-between"
            (click)="this.saveEventClickForReloadOverlayButton = $event; this.displayDocumentsModal = true; this.getModelesDocuments();"
            #buttonDocument>
            <img src="./assets/img/documents.svg" width="20" height="20" class="img-fluid mb-2"
              style="margin-top: 4px" />
            <p class="mb-0">DOCUMENTS</p>
          </div>
          }
        </div>
      </div>
    </div>
    <div class="alert alert-warning mt-1 mb-0 d-flex justify-content-center flex-column align-items-center"
      *ngIf="alertInfo && alertInfo.length > 0">
      <span *ngFor="let alert of alertInfo">
        {{alert}}<br>
      </span>
    </div>

    <div class="alert alert-warning mt-1 d-flex justify-content-center"
      *ngIf="meeting?.verrouille === false && amountOfEventsForMeetingNonPreparee > 0">
      <i class="bi bi-bell-fill me-2"></i>
      <span *ngIf="amountOfEventsForMeetingNonPreparee === 1">{{ amountOfEventsForMeetingNonPreparee }} évènement
        présent dans la séance. Modifiez le statut de celle-ci en
        “Verrouillée” afin de pouvoir les visualiser.</span>
      <span *ngIf="amountOfEventsForMeetingNonPreparee > 1">{{ amountOfEventsForMeetingNonPreparee }} évènements
        présents dans la séance. Modifiez le statut de celle-ci en
        “Verrouillée” afin de pouvoir les visualiser.</span>
    </div>

    <super-tabs-xl [tabs]="itemsTab" (activeTab)="changeTabView($event)" [activeIndex]="activeIndex"></super-tabs-xl>

    <div class="fiche-point-content-info" *ngIf="activeTab === 'pointsInMeetings'">
      <i-table-tree #SuperTreeTable *ngIf="pointsTreeWithEvents?.datas.length >= 1"
        [ngClass]="{ 'size-on-reorder': isReordering }" [defaultExpanded]="true" [hideDeleteSelection]="true"
        [reorder]="isReordering" (onReorderRow)="onReorderRow($event)" [forselection]="forSelectionPointsTree"
        [forselectionDefaultOption]="true" [items]="pointsTreeWithEvents?.datas" [columns]="columnsTree"
        (onClickRow)="openPoint($event, 'linked')" id="super-points-linked-table-trees-1"
        [height]="'calc( 100vh - 300px)'" [multiselect]="true" [menu]="menuPoints" [paginator]="false"
        (menuItemsRowClick)="receive_menu($event)" class="super-table-tree">
        <div class="d-flex gap-2">
          <i-button styleClass="blue" text="Renumérotation" [childrenItems]="numberingButtons"></i-button>

          <idel-layout-toggler [(layout)]="currentLayout" (layoutChange)="changeJustifyOptions()"></idel-layout-toggler>

        </div>
      </i-table-tree>
      <super-table *ngIf="nombreNiveauxTree === 0 && points.length > 0" [autoLayout]="true"
        [ngClass]="{ 'size-on-reorder': isReordering }" #SuperTablePointLinked [hideDeleteSelection]="true"
        [reorder]="isReordering" (onReorderRow)="onReorderRow($event)" [forselection]="forSelectionPoints"
        [forselectionDefaultOption]="true" [items]="points" [columns]="columns"
        (onClickRow)="openPoint($event, 'linked')" [height]="'calc(100vh - 200px)'" [multiselect]="true"
        [paginator]="false" [menu]="menuPoints" (menuItemsRowClick)="receive_menu($event)">
        <div class="d-flex">
          <p-checkbox name="groupname" value="val1" [(ngModel)]="filterTable" binary="true"
            (ngModelChange)="onFilterTableChange()" label="Afficher Titre, Intro & Conclusion"
            class="me-4"></p-checkbox>
          <div class="d-flex gap-2">
            <i-button styleClass="blue" text="Renumérotation" [childrenItems]="numberingButtons"></i-button>
            <idel-layout-toggler [(layout)]="currentLayout" [tooltipPosition]="'left'"
              (layoutChange)="changeJustifyOptions()"></idel-layout-toggler>
          </div>
        </div>

      </super-table>

      <div class="h-100 d-flex flex-column align-items-center justify-content-center" *ngIf="points.length === 0">
        <div class="mt-5" align="center">
          <idel-layout-toggler [(layout)]="currentLayout" (layoutChange)="changeJustifyOptions()"></idel-layout-toggler>
          <br /><br />
          <i class="bi bi-cup-hot-fill mt-5" style="color: #24344b; opacity: 0.2; font-size: 40px"></i>
          <h3 class="text-center">Aucun point</h3>
          <p class="text-muted">Aucun point n'est ajouté à cette séance</p>
        </div>
      </div>


    </div>
    <div class="fiche-point-content-info" *ngIf="activeTab === 'plannedPointsInMeetings'">

      <super-table #superTablePointsNot [forselection]="forSelectionPointsNotLinked" [forselectionDefaultOption]="true"
        [hideDeleteSelection]="true" (columnSelected)="receive_selected($event)" [items]="notLinkedPoints"
        [columns]="columnsPointsNotLinked" (onClickRow)="openPoint($event, 'notLinked')"
        [height]="'calc( 100vh - 250px)'" [multiselect]="true" [menu]="menuPointsNotLinked" [paginator]="false"
        (menuItemsRowClick)="receive_menuNotLinked($event)" id="super-points-planned-table-1"
        [novalue]="noValuePointsPlannedInMeeting"></super-table>
    </div>
    <div style="height: 77.5vh; overflow: hidden;" class="ps-2 pe-2 fiche-point-content-info"
      *ngIf="activeTab === 'documents'">
      <idel-documents-n-files [target]="{scope: 'meeting', id: meeting.id}" [meeting]="meeting"
        (filesCounterChange)="updateDocumentsTabCounter($event)"></idel-documents-n-files>
    </div>
    <div class="fiche-point-content-info" *ngIf="activeTab === 'files' && rightsOfSeance.edit">
      <app-files [hasLoaded]="hasLoaded" [rights]="rightsOfSeance" [files]="files" [pointId]="pointId"
        [meeting]="meeting" (emitSuccessUpload)="getFiles()"></app-files>
    </div>
    <div class="fiche-point-content-info" *ngIf="activeTab === 'historic' && rightsOfSeance.edit">
      <super-table #superTableMeetingHistoric [forselectionDefaultOption]="false" [multiselect]="false"
        [items]="meetingHistoric" [columns]="columnsHistoric" id="super-table-meeting-historic"
        [height]="'calc( 100vh - 300px)'" [novalue]="noValueHistoricForMeeting"></super-table>
    </div>
    <div class="fiche-point-content-info" *ngIf="activeTab === 'recipients' && rightsOfSeance.edit">
      <idel-recipients-n-actions [target]="{scope: 'meeting', id: meeting.id}"></idel-recipients-n-actions>
    </div>
    <div class="fiche-point-content-info" *ngIf="activeTab === 'infos'">
      <app-infos-meeting [displayingInTab]="true"></app-infos-meeting>
    </div>
  </div>
  }@else {
  <div class="w-100 h-100 d-flex align-items-center justify-content-center">
    <span>
      <i-loader></i-loader>
    </span>
  </div>
  }
</section>

<p-confirmDialog #cd appendTo="body" styleClass="super-compos-modal-content confirmModal" header="Confirmation"
  icon="pi pi-exclamation-triangle" key="detailsMeetingModal">

</p-confirmDialog>

<p-dialog styleClass="super-compos-modal-content" [(visible)]="showRegenerateModal" [modal]="true"
  [style]="{ width: '30vw' }" appendTo="body" [closable]="false">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title super-compos-modal-title">Générer le document</h5>
      <super-button styleClass="red" (click)="showRegenerateModal = false" text="Annuler"></super-button>
    </div>
  </p-header>
  <section [formGroup]="form">
    <label class="super-compos-label-input">Type de document</label>
    <p-dropdown [virtualScroll]="true" [itemSize]="30" formControlName="modeleId"
      (onChange)="checkIfAlreadyInDocumentListPoint($event); setActualDocument($event)" [options]="modelesLV"
      styleClass="w-100" [placeholder]="'selectModeles' | translate" appendTo="body" [filter]="true"
      [readonly]="dropdownDisabled">
      <ng-template let-item pTemplate="item">
        <div class="d-flex align-items-center justify-content-between">
          <div class="truncateLabel">{{ item.label }}</div>
          <div><i class="fas fa-info-circle" [pTooltip]="item.label"></i></div>
        </div>
      </ng-template>
    </p-dropdown>
    <section class="separator-border mt-4" *ngIf="documentAlreadyInList === false">
      <div class="mt-3 mb-4 text-center d-flex align-items-center justify-content-center flex-column">
        <p-checkbox *ngIf="form.value.modeleId" [label]="'updateDocumentBeforeGenerate' | translate" binary="true"
          formControlName="updateBefore"></p-checkbox>
        <super-button styleClass="green mt-4" [disabled]="!form.value.modeleId" text="{{ 'generateNew' | translate }}"
          (click)="generateDoc()"></super-button>
      </div>
    </section>
    <section class="separator-border mt-4" *ngIf="documentAlreadyInList">
      <b class="mt-2">Êtes-vous sûr?</b>
      <p>
        Si vous regénérez le document, les modifications que vous avez apportées directement au document seront perdues.
      </p>
      <div>
        <p-radioButton formControlName="regenerateMode" value="replace" inputId="regen"></p-radioButton>
        <label class="mb-0 ms-2" for="regen"><b>Regénérer et remplacer</b></label>
      </div>
      <div class="ms-4 mt-2 mb-2" *ngIf="form.value.regenerateMode === 'replace'">
        <p-checkbox [label]="'updateDocumentBeforeGenerate' | translate" binary="true"
          formControlName="updateBefore"></p-checkbox>
      </div>
      <div *ngIf="actualDocumentInModal?.isAlreadyGeneratedAndSaved">
        <p-radioButton formControlName="regenerateMode" value="update" inputId="update"></p-radioButton>
        <label class="mb-0 ms-2" for="update"><b>Modifier</b></label>
      </div>
      <div class="mt-3 mb-4 text-center d-flex align-items-center justify-content-center flex-column">
        <super-button styleClass="green mt-4" text="{{ 'generateNew' | translate }}"
          (click)="generateDoc()"></super-button>
      </div>
    </section>
  </section>
</p-dialog>

<app-actions-point *ngIf="displayActionsModal" [point]="menuEvents" (action)="handleClickAction($event)">
</app-actions-point>

<p-dialog [(visible)]="displayDocumentsModal" modal="true" [closable]="true" [showHeader]="false" [resizable]="false"
  [style]="{ width: '40vw', minWidth: '40vw', maxWidth: '40vw' }">
  <div class="d-flex justify-content-between align-items-center">
    <p class="actions__title mb-0">Documents</p>
    <i class="bi bi-x-circle" (click)="displayDocumentsModal = false" style="font-size: 20px; cursor: pointer"></i>
  </div>
  <ng-template pTemplate>
    <p *ngIf="documentsOverlayItems.length > 0" class="text-muted mb-4">
      <i class="bi bi-info-circle-fill me-2"></i>{{ 'clickondocument' | translate }}
    </p>
    <div *ngFor="let item of documentsOverlayItems" class="mt-1 border-bottom">
      <a class="dropdown-item d-flex my-2">
        <div class="d-flex align-items-center">
          <i *ngIf="item.rights.canDownloadPdf === true" (click)="downloadModelDoc(item)"
            class="bi bi-download blue-icon biggerIcon me-2" pTooltip="Télécharger le document"
            tooltipPosition="bottom"></i>
          <i (click)="openModelDoc(item)" class="bi bi-eye-fill blue-icon biggerIcon"
            pTooltip="Prévisualiser le document en plein écran" tooltipPosition="bottom"
            *ngIf="item?.isAlreadyGeneratedAndSaved === true || item?.lastFinishedGenerationRequest"></i>
          <div (click)="openModelDoc(item)" class="ms-3">
            <p class="docTitle mb-0">
              {{ item?.description }}
            </p>
            <p class="dropdown-item-info docInfo mb-0" *ngIf="!item?.isAlreadyGeneratedAndSaved">
              {{
              item?.lastFinishedGenerationRequest
              ? 'Aperçu du ' +
              (item?.lastFinishedGenerationRequest?.lastRequestDateTime | momentFormat: 'DD/MM/YYYY à HH:mm')
              : "Pas encore d'aperçu"
              }}
            </p>
            <p class="dropdown-item-info mb-0" *ngIf="item?.isAlreadyGeneratedAndSaved">
              Généré
              {{
              item?.generatedAndSavedAtDateTime
              ? 'le ' + (item?.generatedAndSavedAtDateTime | momentFormat: 'DD/MM/YYYY à HH:mm')
              : ''
              }}
            </p>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <p-tag styleClass="ms-3 me-3" *ngIf="item?.myLastGenerationRequest?.statutId === 1" severity="info"
            value="{{ statusDocumentsGlobal | label_by_id: item?.myLastGenerationRequest?.statutId | translate }}"
            [rounded]="true"></p-tag>
          <p-tag styleClass="ms-3 me-3" *ngIf="item?.myLastGenerationRequest?.statutId === 2" severity="warning"
            value="{{ statusDocumentsGlobal | label_by_id: item?.myLastGenerationRequest?.statutId | translate }}"
            [rounded]="true"></p-tag>
          <p-tag styleClass="ms-3 me-3" *ngIf="item?.myLastGenerationRequest?.statutId === 3" severity="success"
            value="{{ statusDocumentsGlobal | label_by_id: item?.myLastGenerationRequest?.statutId | translate }}"
            [rounded]="true"></p-tag>
          <p-tag styleClass="ms-3 me-3" *ngIf="
              item?.myLastGenerationRequest !== null &&
              item?.myLastGenerationRequest?.statutId !== 1 &&
              item?.myLastGenerationRequest?.statutId !== 2 &&
              item?.myLastGenerationRequest?.statutId !== 3
            " severity="danger"
            value="{{ statusDocumentsGlobal | label_by_id: item?.myLastGenerationRequest?.statutId | translate }}"
            [rounded]="true"></p-tag>

          <span class="documentsActionBtn"
            *ngIf="item?.isAlreadyGeneratedAndSaved === false || item?.rights?.canSubmitModelePreviewRequest"
            (click)="preview(item)" pTooltip="Créer un document pour avoir un aperçu en PDF"
            tooltipPosition="left">APERÇU</span>

          <span class="documentsActionBtn ms-3"
            *ngIf="item?.isAlreadyGeneratedAndSaved === false && item?.rights?.canGenerateModele"
            (click)="openGenerateAndPatch(item)" pTooltip="Générer" tooltipPosition="left">Générer</span>

          <span class="documentsActionBtnConforme ms-3"
            *ngIf="rightsOfSeance?.canUseiSign && item?.isAlreadyGeneratedAndSaved && item?.rights?.canSendToiSign && !item?.rights.iSignStatus"
            (click)="generateSign('meeting', item)" pTooltip="Signer" tooltipPosition="left">Signer</span>
          <span *ngIf="rightsOfSeance?.canUseiSign && item?.rights.iSignStatus > 0" [ngClass]="{
              'documentsActionBtnEdit': item?.rights.iSignStatus === 1,
              'documentsActionBtnSuccess': item?.rights.iSignStatus === 2,
              'documentsActionBtnCancel': item?.rights.iSignStatus === 3 || item?.rights.iSignStatus === 4
            }" class="ms-3"
            [pTooltip]="item?.rights.iSignStatus === 1 ? 'Signature en cours' : item?.rights.iSignStatus === 2 ? 'Signature signée' : item?.rights.iSignStatus === 3 ? 'Signature refusée' : item?.rights.iSignStatus === 4 ? 'Signature en erreur' : ''"
            tooltipPosition="left">
            <i class="bi bi-vector-pen me-1"></i>
            {{ item?.rights.iSignStatus === 1 ? ' En cours' : item?.rights.iSignStatus === 2 ? ' Signé' :
            item?.rights.iSignStatus === 3 ? ' Refusé' : item?.rights.iSignStatus === 4 ? ' Erreur' : '' }}
          </span>



          <span class="documentsActionBtnCancel ms-3" *ngIf="item?.rights?.canCancelModelePreviewRequest"
            pTooltip="Annuler la prévisualisation" tooltipPosition="left" (click)="cancelPreview(item)"
            tooltipPosition="left">Annuler</span>

          <span class="documentsActionBtnEdit ms-3" (click)="editDocument(item)" pTooltip="Modifier le document"
            tooltipPosition="left"
            *ngIf="item?.isAlreadyGeneratedAndSaved && item?.rights.canGenerateModele">Modifier</span>
        </div>
      </a>
    </div>
    <div class="d-flex justify-content-between mt-4">
      <super-button styleClass="blue" text="Générer un document" icon="bi bi-file-earmark-plus-fill" iconPosition="left"
        (click)="generateModeleDoc(); getModelesDocuments()">
      </super-button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog styleClass="super-compos-modal-content" [(visible)]="openCreationModelPointBasedOnExistingPoint"
  [modal]="true" [style]="{ width: '30vw' }" appendTo="body" [closable]="false">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title super-compos-modal-title">Créer un modèle de point</h5>
      <div class="d-flex">
        <super-button styleClass="green me-2" (click)="createNewModelPoint()" text="Sauvegarder"></super-button>
        <super-button styleClass="red" (click)="openCreationModelPointBasedOnExistingPoint = false"
          text="Annuler"></super-button>
      </div>
    </div>
  </p-header>
  <section [formGroup]="formNewModelePoint">
    <div class="row">
      <div class="col-md-12 mb-2">
        <label class="input-label d-block">Description du modèle *</label>
        <input type="text" pInputText formControlName="description" class="w-100" placeholder="Description du modèle" />
      </div>
    </div>
  </section>
</p-dialog>

<p-dialog [visible]="displayActionsModal2" [style]="{ width: '30vw', minWidth: '30vw', maxWidth: '30vw' }"
  class="modal-actions" (visibleChange)="displayActionsModal2 = false" [header]="'Actions'">
  <div *ngFor="let category of categoryActions">
    <p class="modal-actions__category" *ngIf="true">{{category.label}}</p>
    <div *ngFor="let action of category.actions">
      <div *ngIf="action.condition" class="modal-actions__action"
        (click)="displayActionsModal2 = false; action.action()">
        <div class="modal-actions__action__left">
          <img *ngIf="action.img" [src]="action.img" class="modal-actions__action__left__img" />
          <i *ngIf="action.icon" [class]="action.icon + ' modal-actions__action__left__icon'"></i>
          <p class="modal-actions__action__left__label">{{ action?.label }}</p>
        </div>
        <i class="bi bi-arrow-right"></i>
      </div>
    </div>
  </div>
</p-dialog>

<app-export-idelibe-modal *ngIf="openDialogExport" [openDialogExport]="openDialogExport" [typeExport]="exportDialog"
  [exportItems]="exportItems" [meetingId]="meetingId" [iAdminUsers]="iAdminUsers"
  (closeModal)="openDialogExport = $event">
</app-export-idelibe-modal>



<p-dialog [visible]="isManualNumberingDialogOpen()"
  (visibleChange)="pointsToNumber.set([]);  isManualNumberingDialogOpen.set($event)" [blockScroll]="true"
  [header]="'Renumération manuelle des points '" [style]="{width: '75vw'}" class="position-relative">

  <div class="my-3 d-flex position-absolute" style="right: 75px;
    top: 5px;">
    <i-button styleClass="green ms-auto" text="Sauver l'ordre des points" icon="bi bi-check"
      [style]="{marginLeft: 'auto'}" [loading]="savingPointsNewOrder()" [disabled]="savingPointsNewOrder()"
      (click)="savingPointsNewOrder() ? '':onSavePointsToNumberNewOrder()"></i-button>
  </div>

  <div class="points-to-number">
    <div class="points-to-number__element">
      <div class="points-to-number__element__drag-icon">
      </div>
      <span class="points-to-number__element__index  fw-semibold">
        Ordre
      </span>
      <div class="points-to-number__element__title fw-semibold">Titre</div>
      <div class="points-to-number__element__service fw-semibold">Service</div>
      <div class="points-to-number__element__lock-icon fw-semibold">
        Clôturé
      </div>
      <div class="points-to-number__element__move-icons">

      </div>

    </div>
    @for(point of pointsToNumber(); track point.id; let index = $index; let last = $last) {
    <div class="points-to-number__element" (click)="$event.stopPropagation();selectPointToDrag(point,index, $event)"
      [ngStyle]="{
       'background-color': isPointSelected(point) ? 'var(--secondary-color)' : '',
      
       }" draggable="true" [id]="'row-'+ point.id" [class.cursor-move]="isPointSelected(point)"
      [class.cursor-pointer]="!isPointSelected(point)">

      <div class="points-to-number__element__drag-icon">
        <i class="bi bi-grip-vertical"></i>
      </div>
      <span class="points-to-number__element__index fw-bold">
        {{index + 1}}
      </span>
      <div class="points-to-number__element__title">{{point.title}}</div>
      <div class="points-to-number__element__service">{{point.service}}</div>
      <div class="points-to-number__element__lock-icon">
        @if(point.closed) {
        <span>
          <i class="bi bi-lock-fill"></i>
        </span>
        }@else {
        <span>
          <i class="bi bi-unlock"></i>
        </span>
        }
      </div>
      <div class="points-to-number__element__move-icons">
        @if(!isPointSelected(point)) {

        @if (index !== pointsToNumber().length - 1) {
        <span class="points-to-number__element__move-icons__icon" [pTooltip]="
                              'Déplacer en dernier'
                            " [tooltipPosition]="'left'"
          (click)="$event.stopPropagation();switchPointOrder(index, 'goLast')"><i
            class="bi bi-chevron-double-down"></i></span>
        <span class="points-to-number__element__move-icons__icon" [pTooltip]="
                              'Déplacer en-dessous'
                                
                            " [tooltipPosition]="'left'"
          (click)="$event.stopPropagation();switchPointOrder(index, 'goDown')"><i class="bi bi-chevron-down"></i></span>
        }
        @if (index !== 0) {
        <span class="points-to-number__element__move-icons__icon" [pTooltip]="
                              'Déplacer au-dessus'
                            " [tooltipPosition]="'left'"
          (click)="$event.stopPropagation();switchPointOrder(index, 'goUp')"><i class="bi bi-chevron-up"></i></span>
        <span class="points-to-number__element__move-icons__icon" [pTooltip]="
                             'Déplacer en premier'
                            " [tooltipPosition]="'left'"
          (click)="$event.stopPropagation();switchPointOrder(index, 'goFirst')"><i
            class="bi bi-chevron-double-up"></i></span>
        }
        }
      </div>

    </div>
    @if(!last) {

    <div class="border" style="height: 1px; width: 100%; background-color: var(--secondary-color); opacity: .7;"></div>
    }
    }
  </div>
  <div class="position-absolute how-to-select">
    <idel-infos-chip [info]="'Maj + Click pour faire une sélection groupée'"></idel-infos-chip>
  </div>

</p-dialog>

<div id="ghost" class="ghost" #ghost></div>

<p-dialog [(visible)]="modalPdfViewer" [style]="{height: '90vh', width: '45vw'}" [header]="'Fichier de la séance'">
  @defer {
  <i-viewer [file]="currentFileForViewer" [viewerConfig]="pdfViewerConfig" styleClass="h-100 d-block"></i-viewer>
  }@placeholder(minimum 1250ms) {
  <i-loader></i-loader>
  }
</p-dialog>